import React, { useEffect, useRef, useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/TrackingJob.css";
import { client, singleProfile } from "../../Constant";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import config from "../../config";
import moment from "moment";
import GoogleMapReact from "google-map-react";

const TrackingJob = ({ auth }) => {
    const mapRef = useRef();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [job, setJob] = useState();
    const getJob = async () => {
        const headers = config.bearerHeaders(auth.token);
        const res = await config.getApi(config.services.singleJob(id), headers);
        if (res) {
            setJob(res.response.data);
            // console.log(res);
            setLoading(false);
        }
    };
    useEffect(() => {
        getJob();
    }, []);

    if (loading) {
        return <div />;
    }

    return (
        <>
            <Header />
            <section className="tracking_job">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-9">
                            <div className="row align-items-center">
                                <div className="col-md-7">
                                    <div className="heading_wrapper">
                                        <h4>Tracking Job Location</h4>
                                        <p>
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incidid
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="button-group">
                                        <Link
                                            to={`/job-detail/${id}`}
                                            className="btn back_btn"
                                        >
                                            <i
                                                className="fa fa-angle-left"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Go back to Job
                                        </Link>
                                        <button className="btn chat_now">
                                            <i
                                                className="fa fa-comment-o"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Chat Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="tracking_map mt-5">
                                <div className="top_bar">
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="about_job">
                                                <p className="job_id">
                                                    Job Id ({job.id})
                                                </p>
                                                <h5 className="job_title">
                                                    {job.title}
                                                </h5>
                                                <p className="address">
                                                    <i
                                                        className="fa fa-map-marker"
                                                        aria-hidden="true"
                                                    ></i>{" "}
                                                    {job.destination_address}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="care_giver">
                                                <div className="img_box">
                                                    <figure>
                                                        <img
                                                            src={
                                                                job.user_id ==
                                                                auth.user.id
                                                                    ? config.returnImage(
                                                                          job.care_giver
                                                                      )
                                                                    : config.returnImage(
                                                                          job.user
                                                                      )
                                                            }
                                                            alt=""
                                                        />
                                                    </figure>
                                                    <div className="name">
                                                        <h6 className="care_giver_name">
                                                            {job.user_id ==
                                                            auth.user.id
                                                                ? job.care_giver
                                                                      .full_name
                                                                : job.user
                                                                      .full_name}
                                                        </h6>
                                                        <span className="type">
                                                            {job.service.title}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="rating">
                                                    <p>
                                                        <i
                                                            className="fa fa-star"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        {job.user_id ==
                                                        auth.user.id
                                                            ? job.care_giver
                                                                  .customer_rating
                                                            : job.user
                                                                  .care_giver_rating}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <GoogleMapReact
                                    bootstrapURLKeys={{
                                        key: config.mapsApiKey,
                                    }}
                                    defaultZoom={5}
                                    defaultCenter={{
                                        lat: parseFloat(job.destination_lat),
                                        lng: parseFloat(job.destination_lng),
                                    }}
                                    style={{ height: 500, width: "100%" }}
                                    ref={mapRef}
                                />
                                {/* <div
                                    id="map"
                                    style={{
                                        height: 500,
                                        width: "100%",
                                    }}
                                ></div> */}
                                {/* <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509161.852438123!2d-123.7978655197117!3d37.19306321312955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2s!4v1644948662957!5m2!1sen!2s"
                                    width="100%"
                                    height="500"
                                    style={{ border: "0" }}
                                    allowFullScreen=""
                                    loading="lazy"
                                ></iframe> */}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="client-box">
                                <div className="img_box">
                                    <figure>
                                        <img src={client} alt="" />
                                    </figure>
                                </div>
                                <div className="about_client">
                                    <h5 className="name">
                                        {job.user_id == auth.user.id
                                            ? job.care_giver.full_name
                                            : job.user.full_name}
                                    </h5>
                                    <span className="type">
                                        {job.user_id == auth.user.id
                                            ? "Care Giver"
                                            : "Client"}
                                    </span>
                                    <p className="member_since">
                                        Member Since -{" "}
                                        {job.user.id == auth.user.id
                                            ? moment(
                                                  job.care_giver.created_at
                                              ).format("MMM YYYY")
                                            : moment(
                                                  job.user.created_at
                                              ).format("MMM YYYY")}
                                    </p>
                                </div>
                                <div className="address">
                                    <p className="location">
                                        <i
                                            className="fa fa-map-marker"
                                            aria-hidden="true"
                                        ></i>{" "}
                                        {job.user_id == auth.user.id
                                            ? `${job.care_giver.city} ${job.care_giver.country}`
                                            : `${job.user.city} ${job.user.country}`}
                                    </p>
                                    <p>
                                        {job.user_id == auth.user.id
                                            ? job.care_giver.bio
                                            : job.user.bio}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(TrackingJob);
